export enum articlesCreateTypes {
  FETCH_ARTICLES_CREATE_REQUEST = "FETCH_ARTICLES_CREATE_REQUEST",
  FETCH_ARTICLES_CREATE_SUCCESS = "FETCH_ARTICLES_CREATE_SUCCESS",
  FETCH_ARTICLES_CREATE_FAILURE = "FETCH_ARTICLES_CREATE_FAILURE",
}